export default "__VITE_ASSET__2Z7JMl8S__"